// ----------------------------------------------------------------
import { createFileRoute } from '@tanstack/react-router';
import TaskGridPreviewPage from '@/pages/task-grid';
// ----------------------------------------------------------------

/**
 * Preview route for Ticket 2's MVP dynamic grid (TanStack Table + TanStack Form).
 * This is a route setup for '/task-grid/' route.
 */
export const Route = createFileRoute('/_authenticated-layout/task-grid/')({
  component: TaskGridPreviewPage,
});
